import { request } from '../../index';

const PREFIX = '/user/sysPermission';

// 定义单个权限节点的类型
export interface PermissionNode {
  createOrg: string | null; // 创建组织
  createBy: string | null; // 创建人
  createTime: string; // 创建时间 (格式: "YYYY-MM-DD HH:mm:ss")
  updateBy: string | null; // 更新人
  updateTime: string; // 更新时间 (格式: "YYYY-MM-DD HH:mm:ss")
  isDeleted: number; // 是否删除 (0: 否, 1: 是)
  deleteTime: string | null; // 删除时间
  permId: number; // 权限ID
  parentPermId: number; // 父级权限ID
  permName: string; // 权限名称
  permCode: string; // 权限编码
  permType: number; // 权限类型 (例如: 1-菜单, 2-子菜单, 3-按钮/功能)
  serviceCode: string; // 服务代码
  sortOrder: number; // 排序顺序
  status: number; // 状态 (例如: 1-启用, 0-禁用)
  displayStatus: boolean; // 显示状态 (true: 显示, false: 隐藏)
  children: PermissionNode[]; // 子权限节点数组 (递归结构)
}

/**
 * 数据对象
 *
 * RolePermissionVO
 */
export interface RolePermissionVO {
  /**
   * 角色拥有的权限ID列表
   */
  permIds?: number[];
  /**
   * 角色ID
   */
  roleId?: string;
  /**
   * 角色权限标识 (如 ROLE_FINANCE)
   */
  roleKey?: string;
  /**
   * 角色名称
   */
  roleName?: string;
  /**
   * 角色类型: SYSTEM系统 / CUSTOM自定义
   */
  roleType?: string;
}

/**
 * 获取菜单/权限列表(对外)
 */
export const getPermListOuter = () => {
  return request.get<PermissionNode[]>(`${PREFIX}/getPermListOuter?serviceCode=CREATIVE`, {
    allowCancel: false,
  });
};
